import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: {
        welcome: 'Welcome to the Care Copilot',
        select_language: 'Select Language',
        dementia_basics: 'Dementia Basics',
        mental_health: 'Mental Health',
        physical_health: 'Physical Health',
        financial_wellbeing: 'Financial Wellbeing',
        clinical_information: 'Clinical Information',
        caregiver_stress: 'Managing Caregiver Stress',
        care_team: 'Your Care Team',
        loading: 'Loading...',
        error: 'Error loading content',
        no_data: 'No data available',
      },
    },
    pt: {
      translation: {
        welcome: 'Bem-vindo ao Copiloto de Cuidados',
        select_language: 'Selecionar Idioma',
        dementia_basics: 'Noções Básicas de Demência',
        mental_health: 'Saúde Mental',
        physical_health: 'Saúde Física',
        financial_wellbeing: 'Bem-estar Financeiro',
        clinical_information: 'Informações Clínicas',
        caregiver_stress: 'Gerenciando o Estresse do Cuidador',
        care_team: 'Sua Equipe de Cuidados',
        loading: 'Carregando...',
        error: 'Erro ao carregar conteúdo',
        no_data: 'Nenhum dado disponível',
      },
    },
    es: {
      translation: {
        welcome: 'Bienvenidos al Copiloto de Atención',
        select_language: 'Seleccionar Idioma',
        dementia_basics: 'Conceptos Básicos de Demencia',
        mental_health: 'Salud Mental',
        physical_health: 'Salud Física',
        financial_wellbeing: 'Bienestar Financiero',
        clinical_information: 'Información Clínica',
        caregiver_stress: 'Manejo del Estrés del Cuidador',
        care_team: 'Su Equipo de Cuidado',
        loading: 'Cargando...',
        error: 'Error al cargar contenido',
        no_data: 'No hay datos disponibles',
      },
    },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;